export default __webpack_public_path__ + "static/media/Glacier-Caves01.00cd7685.webp";